import React from 'react';
import { Modal } from 'react-bootstrap';
import { deleteGratuity, cancelDeleteGratuity } from 'actions/library/gratuity';
import { connect } from 'react-redux';
import styles from './ConfirmDeleteModal.css';

class ConfirmDeleteModal extends React.Component {
  render() {
    const { showDeleteGratuityModal, deletedGratuity } = this.props;
    return (
      <Modal
        show={showDeleteGratuityModal}
        onHide={this._onHide}
        dialogClassName={`modal-dialog ${styles.dialog}`}
      >
        <Modal.Header bsClass={`modal-header ${styles.header}`}>
          Delete Gratuity
        </Modal.Header>
        <Modal.Body>
          {deletedGratuity && (
            <p>
              Are you sure want to delete <b>{deletedGratuity.name}</b> ? This
              action cannot be undone
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button onClick={this._onHide} className="btn btn-default">
            Cancel
          </button>
          <button onClick={this._onConfirm} className="btn btn-danger">
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _onHide = () => {
    this.props.dispatch(cancelDeleteGratuity());
  };

  _onConfirm = () => {
    const { deletedGratuity, dispatch, gratuities } = this.props;
    dispatch(deleteGratuity(deletedGratuity.id, gratuities));
  };
}

function mapStateToProps(state) {
  const {
    deletedGratuity,
    showDeleteGratuityModal,
    gratuities,
  } = state.library.gratuity;
  return {
    deletedGratuity,
    showDeleteGratuityModal,
    gratuities,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConfirmDeleteModal);
